module.exports = __webpack_public_path__ + "media/images/bg-mobile-6848a5f3465551f5d7edce29d2b93961.png";